<template>
  <mdb-container id="info" class="">
    <mdb-row>
      <mdb-col lg="5">
        <mdb-view class="rounded z-depth-2 mb-lg-0 mb-4" hover>
          <img class="img-fluid" src="../assets/img_1.jpg" alt="Sample image" />
          <a>
            <mdb-mask overlay="white-slight" waves />
          </a>
        </mdb-view>
      </mdb-col>
      <mdb-col lg="7">
        <h3 class="font-weight-bold mb-3 p-0">
          <strong>¿Quiénes Somos?</strong>
        </h3>
        <p>
          Nos especializamos en ofrecerle a nuestros clientes la más alta
          calidad en servicio y eficiencia. Hemos servido a Puerto Rico por más
          de 40 años. A través de los años hemos ampliado nuestros servicios
          para que usted obtenga un trabajo de calidad, en poco tiempo y a
          precios competitivos.
        </p>
        <p>
          En Imprenta Las Amèricas lo más importante son nuestros clientes.
          Estamos comprometidos en ofrecerles servicios de excelencia y un trato
          personal con gran profesionalismo y con garantía de satisfacción
          total.
        </p>
        <p>
          Visita nuestra facilidades, comuníquese por el teléfono o escríbenos
          para una cotización libre de costo. Entrega gratis. *(ciertas
          restricciones aplican).
        </p>
        <!-- <mdb-btn outline="white" size="md" icon="clone">Estimados Gratis</mdb-btn> -->
      </mdb-col>
    </mdb-row>
    <!-- <hr class="my-5" /> -->
  </mdb-container>
</template>

<script>
import { mdbContainer, mdbRow, mdbCol, mdbMask, mdbView } from "mdbvue";
export default {
  name: "BlogPage",
  components: {
    mdbContainer,
    mdbRow,
    mdbCol,
    mdbMask,
    mdbView,
  },
};
</script>
